// @ts-nocheck

// Update Product Title Colors
function tagProductTitleParagraphs() {
  document.querySelectorAll('.product-card .text-block p').forEach(el => {
    const text = el.textContent.trim().toLowerCase();
    if (['release', 'signal', 'mobilize', 'sport', 'release sport'].includes(text)) {
      el.classList.add(text === 'release sport' ? 'sport' : text);
      // Optional: log for dev
      // console.log(`✅ Class "${text}" added to`, el);
    }
  });
}

// Run on DOM load
document.addEventListener('DOMContentLoaded', () => {
  // Initial pass (may be too early for Shopify components)
  setTimeout(() => {
    tagProductTitleParagraphs();
  }, 300); // 300ms delay to ensure hydration

  // Watch for Shopify section renders, AJAX, or future mutations
  const observer = new MutationObserver(() => {
    tagProductTitleParagraphs();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  const logoutLink = document.querySelector('a[name="account_logout_url"]');

  if (logoutLink) {
    logoutLink.addEventListener("click", function (e) {
      e.preventDefault();             // stop the default logout for now
      e.stopImmediatePropagation();   // stop other handlers temporarily

      console.log("----- CLEAR CART BEFORE LOGOUT -----");

      fetch(`${window.Shopify.routes.root}cart/clear.js`, {
        method: "GET",
        credentials: "include"
      })
        .then(() => {
          console.log("Cart cleared, now logging out");
        })
        .catch(err => {
          console.error("Error clearing cart:", err);
        })
        .finally(() => {
          // Always continue to logout
          window.location.href = logoutLink.getAttribute("href");
        });
    }, true); // capture = true ensures this runs before most theme handlers
  }
});

/* Active carousel slide → mirror the desktop hover gradient on mobile.
   Auto-applies to any .blog-archive-carousel using the gradient card style
   (.blog-card--v2.card-bg__st-gradient-dark) — i.e. wherever there is colour.
   Adds .is-in-view to the centred card on mobile; CSS mirrors :hover for it. */
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');
  function scrollParent(el) {
    var p = el.parentElement;
    while (p && p !== document.body) {
      var ox = getComputedStyle(p).overflowX;
      if ((ox === 'auto' || ox === 'scroll' || ox === 'hidden') && p.scrollWidth > p.clientWidth + 2) return p;
      p = p.parentElement;
    }
    return el.parentElement;
  }
  function setup(carousel) {
    if (carousel.__activeSlideInit) return;
    // Dark Reset's Trusted Voices cards have no card-bg class but style .is-in-view too.
    if (!carousel.querySelector('.blog-card--v2.card-bg__st-gradient-dark') && !carousel.closest('body.pdp-reset')) return; // gradient cards only
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('.resource-list__slide'));
    if (!slides.length) return;
    carousel.__activeSlideInit = true;
    var scroller = scrollParent(slides[0]);
    var raf = null;
    function clearAll() {
      slides.forEach(function (s) { var c = s.querySelector('.blog-card--v2'); if (c) c.classList.remove('is-in-view'); });
    }
    function update() {
      raf = null;
      if (!MQ.matches) return clearAll();
      var r = scroller.getBoundingClientRect(), center = r.left + r.width / 2, best = null, bd = Infinity;
      slides.forEach(function (s) {
        var sr = s.getBoundingClientRect(), d = Math.abs(sr.left + sr.width / 2 - center);
        if (d < bd) { bd = d; best = s; }
      });
      slides.forEach(function (s) { var c = s.querySelector('.blog-card--v2'); if (c) c.classList.toggle('is-in-view', s === best); });
    }
    function onScroll() { if (raf == null) raf = requestAnimationFrame(update); }
    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    (MQ.addEventListener ? MQ.addEventListener('change', onScroll) : MQ.addListener(onScroll));
    update();
  }
  function initAll() { document.querySelectorAll('.blog-archive-carousel').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  setTimeout(initAll, 800);
  setTimeout(initAll, 2000);
  document.addEventListener('shopify:section:load', initAll);
})();


/* Preserve carousel scroll position across video-modal open/close.
   The Horizon dialog scroll-lock sets `body { position: fixed }`, which on some
   devices reflows and resets nested scroll containers (the carousel jumps back
   to slide 1). Save the position when a video trigger is tapped, then restore it
   on every body-style change while the lock is active (covers both open + close). */
(function () {
  var saved = new WeakMap();
  var armed = false;
  function scrollers() { return document.querySelectorAll('.blog-archive-carousel slideshow-slides'); }
  function saveAll() { scrollers().forEach(function (el) { saved.set(el, el.scrollLeft); }); }
  function restoreAll() { scrollers().forEach(function (el) { if (saved.has(el)) el.scrollLeft = saved.get(el); }); }

  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.video-trigger')) { saveAll(); armed = true; }
  }, true);

  new MutationObserver(function () {
    if (!armed) return;
    restoreAll();
    if (getComputedStyle(document.body).position !== 'fixed') armed = false; // lock released → done
  }).observe(document.body, { attributes: true, attributeFilter: ['style'] });
})();
